document.addEventListener('DOMContentLoaded', function () {
  if (typeof window.Swiper !== 'function' && typeof window['Swiper'] !== 'function') {
    // console.error('Swiper is not loaded!');
    return;
  }
  document.querySelectorAll('.logo-swiper').forEach(function (el) {
    // Prevent double initialization
    if (el.swiper) return;
    var nextBtn = el.querySelector('.logo-next');
    var prevBtn = el.querySelector('.logo-prev');
    // Debug: log found elements
    if (!nextBtn || !prevBtn) {
      console.warn('Swiper navigation buttons not found for:', el);
    }
    // Use window.Swiper or window['Swiper']
    var SwiperCtor = window.Swiper || window['Swiper'];
    var instance = new SwiperCtor(el, {
      loop: false,
      slidesPerView: 1,
      spaceBetween: 10,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
    });
    el.swiper = instance;
    // Debug: log instance
    // console.log('Swiper initialized:', el, instance);
  });
});


document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.product-card').forEach((productCard) => {
    const swatchImages = productCard.querySelectorAll('.variant-scroll-container .swatch__image img');

    const swatchData = Array.from(swatchImages).map((img) => {
      let src = img.getAttribute('src');
      if (src && !src.startsWith('http')) {
        src = 'https:' + src;
      }

      const mediaId = img.dataset.mediaId || img.closest('[data-media-id]')?.dataset.mediaId;

      return { src, mediaId };
    });

    const swiperWrapper = productCard.querySelector('.logo-swiper .swiper-wrapper');

    if (!swiperWrapper) return;

    // Clear old slides
    swiperWrapper.innerHTML = '';

    // Add new slides based on swatchData
    swatchData.forEach(({ src, mediaId }) => {
      const slide = document.createElement('div');
      slide.className = 'swiper-slide';

      if (mediaId) {
        slide.setAttribute('data-media-id', mediaId);
      }

      const img = document.createElement('img');
      img.src = src;
      img.alt = '';
      img.loading = 'lazy';

      slide.appendChild(img);
      swiperWrapper.appendChild(slide);
    });

    // Reinitialize or update Swiper instance
    const swiperContainer = productCard.querySelector('.logo-swiper');

    if (swiperContainer && swiperContainer.swiper) {
      // If Swiper instance already exists, update it
      swiperContainer.swiper.update();
    } else {
      // If not initialized yet, you can initialize it like this (if not already done elsewhere)
      new Swiper(swiperContainer, {
        slidesPerView: 3,
        spaceBetween: 10,
        loop: false,
        // other settings if needed
      });
    }
  });
});




document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.product-grid__item').forEach(function (productCard) {
    const swiperContainer = productCard.querySelector('.logo-swiper');
    if (!swiperContainer || !swiperContainer.swiper) return;

    const swiperInstance = swiperContainer.swiper;

    // Select only the variant inputs inside the current productCard
    const variantInputs = productCard.querySelectorAll('.variant-option__button-label input');

    variantInputs.forEach(function (input) {
      input.addEventListener('click', function () {
        const selectedMediaId = this.dataset.mediaId;
        if (!selectedMediaId) return;

        const slides = swiperInstance.slides;
        for (let i = 0; i < slides.length; i++) {
          const slide = slides[i];
          if (slide.dataset.mediaId === selectedMediaId) {
            swiperInstance.slideTo(i); // Move swiper to the matched variant image
            break;
          }
        }
      });
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.resource-list__item').forEach(function (productCard) {
    const swiperContainer = productCard.querySelector('.logo-swiper');
    if (!swiperContainer || !swiperContainer.swiper) return;

    const swiperInstance = swiperContainer.swiper;

    // Select only the variant inputs inside the current productCard
    const variantInputs = productCard.querySelectorAll('.variant-option__button-label input');

    variantInputs.forEach(function (input) {
      input.addEventListener('click', function () {
        const selectedMediaId = this.dataset.mediaId;
        if (!selectedMediaId) return;

        const slides = swiperInstance.slides;
        for (let i = 0; i < slides.length; i++) {
          const slide = slides[i];
          if (slide.dataset.mediaId === selectedMediaId) {
            swiperInstance.slideTo(i); // Move swiper to the matched variant image
            break;
          }
        }
      });
    });
  });
});


document.querySelectorAll('.variant-option__button-label input[type="radio"]').forEach(input => {
  input.addEventListener('change', function () {
    const variantId = this.getAttribute('data-variant-id');
    
    // Find the product card (adjust this selector if needed)
    const productCard = this.closest('.product-card');
    const productLink = productCard?.querySelector('.product-card__link');
    
    if (productLink) {
    const baseUrl = productLink.href.split('?')[0];
      const newUrl = `${baseUrl}?variant=${variantId}`;
      console.log("newUrl" ,newUrl);
      productLink.setAttribute('href', newUrl);
    }

    console.log('Updated link with variant:', variantId);
  });
});


document.addEventListener("DOMContentLoaded", function () {
  const urlParams = new URLSearchParams(window.location.search);
  const variantId = urlParams.get("variant");

  if (variantId) {
    const variantOption = document.querySelector(`[data-variant-id="${variantId}"]`);
    if (variantOption) {
      variantOption.click(); // trigger your variant logic
    }
  }
});